import { __assign, __rest } from "tslib";
import React, { useMemo } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { i18n } from '../i18n';
import { I18nextProvider } from 'react-i18next';
import { WixDesignSystemProvider, } from '@wix/design-system';
import '@wix/design-system/styles.global.css';
export function withProviders(WrappedComponent) {
    // Creating the inner component. The calculated Props type here is the where the magic happens.
    var ComponentWithProviders = function (_a) {
        var locale = _a.locale, onError = _a.onError, wsrProviderProps = _a.wsrProviderProps, dataHook = _a.dataHook, props = __rest(_a, ["locale", "onError", "wsrProviderProps", "dataHook"]);
        var i18nInstance = useMemo(function () { return i18n(locale || 'en'); }, [locale]);
        var onErrorHandler = function (e) {
            onError === null || onError === void 0 ? void 0 : onError(e);
        };
        return ((React.createElement("div", { "data-hook": dataHook },
            React.createElement(ErrorBoundary, { onError: onErrorHandler, fallback: React.createElement("div", null) },
                React.createElement(React.Suspense, { fallback: React.createElement("span", null) },
                    React.createElement(I18nextProvider, { i18n: i18nInstance },
                        React.createElement(WixDesignSystemProvider, __assign({ features: { newColorsBranding: true } }, wsrProviderProps),
                            React.createElement("div", { style: { height: '100%' } },
                                React.createElement(WrappedComponent, __assign({}, props))))))))));
    };
    return ComponentWithProviders;
}
//# sourceMappingURL=Selector.container.js.map